

































































import Vue from "vue";
import CharacterList from "@/components/organisms/CharacterList.vue";
import AttributeList from "@/components/molecules/AttributeList.vue";
import Attribute from "@/components/molecules/Attribute.vue";
import ImageView from "@/components/atoms/ImageView.vue";
import ButtonRound from "@/components/atoms/ButtonRound.vue";

export default Vue.extend({
  components: {
    CharacterList,
    ButtonRound,
    AttributeList,
    Attribute,
    ImageView,
  },
  props: {
    novelId: String,
    character: Object,
  },
  computed: {
    detail() {
      const detail = this.character.detail;
      const map = Object.assign(
        {},
        ...detail.map((d) => ({
          [d.name]: d.value,
        }))
      );

      return map;
    },
    additionalColumn() {
      return this.character.additionalColumn;
    },
    getCharacterKey() {
      const {
        novelId,
        character: { characterId, image },
      } = this;
      if (image && image.startsWith("file:")) {
        return `file:novels/${novelId}/characters/${characterId}.jpg`;
      }
      return image;
    },
  },
});
